import { createI18n } from 'vue-i18n'
import axios from 'axios'

export const i18n = createI18n({
  locale: window.app.product_list.siteLanguageHrefLang,
  messages: {} // You can load the default locale messages here if you have them
})

export function loadLanguageAsync() {
  const locale = window.app.product_list.siteLanguageHrefLang
  const url = window.app.product_list.translationsAssetsPath + `/${locale}.json`

  return axios.get(url).then(response => {
    // Set the locale message after fetching the JSON file
    i18n.global.setLocaleMessage(locale, response.data)
  })
}
